import '@assets/scss/_main.scss'
import * as cms from '@lib/api/operations'
import React from 'react'
import ReactDOM from 'react-dom/client'
import constants from '@constants'
import { Header, Footer } from '@components/common'
import { ManagedUIContext } from '@components/ui/context'
import reportWebVitals from './reportWebVitals'
import { hydrateCustomersAlsoBought } from '@utils/hydrate'

function renderReactNode(
  DOMNode: HTMLElement | null,
  Component: React.ElementType,
  props: Record<string, any> = {}
) {
  if (DOMNode) {
    const root = ReactDOM.createRoot(DOMNode)
    root.render(
      <React.StrictMode>
        <ManagedUIContext>
          <Component {...props} />
        </ManagedUIContext>
      </React.StrictMode>
    )
  }
}

;(async function () {
  const constantsHTML = document.getElementById('srssReact')
  const siteHeaderHTML = document.getElementById('siteHeader')
  const siteFooterHTML = document.getElementById('siteFooter')

  if (constantsHTML) {
    const {
      brand,
      companyId,
      contentfulAccessToken,
      contentfulSpaceId,
      listId,
      locale,
      siteTag,
      shopifyDomain,
      storefrontAccessToken,
      siteDomain,
      countryCode = 'US',
      languageCode = 'EN',
    } = constantsHTML.dataset

    constants.set('CONTENTFUL_ACCESS_TOKEN', contentfulAccessToken)
    constants.set('CONTENTFUL_SPACE_ID', contentfulSpaceId)
    constants.set('SITE_TAG', siteTag)
    constants.set('COMPANY_ID', companyId)
    constants.set('LIST_ID', listId)
    constants.set('BRAND', brand)
    constants.set('LOCALE', locale)
    constants.set('SITE_DOMAIN', siteDomain)
    constants.set('COUNTRY_CODE', countryCode)
    constants.set('LANGUAGE_CODE', languageCode)
    constants.set('SHOPIFY_STORE_DOMAIN', shopifyDomain)
    constants.set('SHOPIFY_STOREFRONT_ACCESS_TOKEN', storefrontAccessToken)
    constants.set('SHOPIFY_COOKIE_EXPIRE', 30)
    constants.set('SHOPIFY_CART_ID_COOKIE', 'shopify_cartId')
    constants.set('SHOPIFY_CUSTOMER_TOKEN_COOKIE', 'shopify_customerToken')
  }

  if (siteHeaderHTML || siteFooterHTML) {
    const globalElements = await cms.getGlobalElements()
    const { navigation, footer, globalSettings } = globalElements
    globalSettings.customersAlsoBoughtData = await hydrateCustomersAlsoBought(
      globalSettings
    )

    renderReactNode(siteHeaderHTML, Header, { navigation, globalSettings })
    renderReactNode(siteFooterHTML, Footer, footer)
  }
})()

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
